import React, { useState } from "react";
import {
  Button,
  Divider,
  Grid,
  FormControl,
  FormLabel,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  makeStyles
} from "@material-ui/core";
import {
  Add as AddIcon,
  EditOutlined as EditOutlinedIcon,
  DeleteForeverOutlined as DeleteForeverOutlinedIcon,
  MoreVertOutlined as MoreVertOutlinedIcon
} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  listLabel: {
    width: "100%",
    marginBottom: "0px"
  },
  listTextPrimary: {
    color: theme.palette.primary.main,
    fontSize: "0.75rem"
  },
  addBtn: {
    textAlign: "right"
  }
}));

interface Props {
  label: string;
  listItems: ListItemProps[];
  onOpenModal: (index?: number) => void;
  onDeleteItem: (index: number) => void;
}

type ListItemProps = {
  primary: string;
  secondary?: string | React.ReactElement;
};

const DynamicForm: React.FC<Props> = props => {
  const classes = useStyles();
  const { label, listItems, onOpenModal, onDeleteItem } = props;

  const [menuState, setMenuState] = useState<{
    open: boolean;
    selectedIndex?: number;
    target?: HTMLElement;
  }>({
    open: false,
    selectedIndex: undefined
  });

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    setMenuState({
      open: true,
      selectedIndex: index,
      target: event.currentTarget
    });
  };

  const handleCloseMenu = () => {
    setMenuState({ open: false, selectedIndex: undefined });
  };

  const handleDelete = () => {
    if (menuState.selectedIndex !== undefined) {
      onDeleteItem(menuState.selectedIndex);
    }
    setMenuState({ open: false, selectedIndex: undefined });
  };

  const handleOpenModal = () => {
    const index = menuState.selectedIndex;
    onOpenModal(index);
    setMenuState({ open: false, selectedIndex: undefined });
  };

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend" className={classes.listLabel}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={9}>
            {label}
          </Grid>
          <Grid item xs={3} className={classes.addBtn}>
            <Button
              variant="contained"
              onClick={handleOpenModal.bind(this, true)}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </FormLabel>

      <List>
        {listItems.map((item, index) => (
          <React.Fragment key={`listItem_${label}_${index}`}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={
                  <Typography className={classes.listTextPrimary}>
                    {item.primary}
                  </Typography>
                }
                secondary={item.secondary}
              />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  onClick={e => {
                    handleOpenMenu(e, index);
                  }}
                >
                  <MoreVertOutlinedIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider component="li" key={`ListItem_divider_${index}`} />
          </React.Fragment>
        ))}

        <Menu
          open={menuState.open}
          onClose={handleCloseMenu}
          anchorEl={menuState.target}
        >
          <MenuItem onClick={handleOpenModal}>
            <ListItemIcon>
              <EditOutlinedIcon />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
          <MenuItem key="menu_delete" onClick={handleDelete}>
            <ListItemIcon>
              <DeleteForeverOutlinedIcon />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        </Menu>
      </List>
    </FormControl>
  );
};
export default DynamicForm;
